import { useEffect, useRef, useState } from "react";
import StarBackground from "../components/StarBackground";

const ShabbatPage = () => {
  const [timeLeft, setTimeLeft] = useState("");
  const havdalahRef = useRef<Date | null>(null);

  useEffect(() => {
    let interval: number | undefined;

    const fetchHavdalah = async () => {
      const res = await fetch(
        "https://www.hebcal.com/shabbat?cfg=json&geonameid=293397&M=on"
      );
      const data = await res.json();

      const havdalah = new Date(
        data.items.find((i: any) => i.category === "havdalah").date
      );

      havdalahRef.current = havdalah;

      const updateCountdown = () => {
        if (!havdalahRef.current) return;

        const now = new Date();
        const diff = havdalahRef.current.getTime() - now.getTime();

        if (diff <= 0) {
          setTimeLeft("");
          // 🔄 פתיחה אוטומטית של האתר
          window.location.reload();
          return;
        }

        const hours = Math.floor(diff / 1000 / 60 / 60);
        const minutes = Math.floor((diff / 1000 / 60) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        setTimeLeft(
          `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
        );
      };

      updateCountdown();
      interval = window.setInterval(updateCountdown, 1000);
    };

    fetchHavdalah();

    return () => {
      if (interval) clearInterval(interval);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#020617] via-[#020617] to-[#030a1c] flex items-center justify-center text-white relative overflow-hidden">
      <StarBackground />

      {/* בס״ד */}
      <div className="absolute top-6 right-8 text-white/80 text-lg tracking-wider">
        בס״ד
      </div>

      {/* Glow */}
      <div className="absolute w-[700px] h-[700px] bg-blue-500/10 blur-[180px] rounded-full top-[-250px] right-[-200px]" />
      <div className="absolute w-[600px] h-[600px] bg-indigo-500/10 blur-[160px] rounded-full bottom-[-250px] left-[-200px]" />

      {/* Card */}
      <div className="relative z-10 max-w-xl text-center backdrop-blur-xl bg-white/[0.04] border border-white/10 rounded-2xl p-14 shadow-[0_20px_60px_rgba(0,0,0,0.6)]">
        {/* Candles */}
        <div className="flex justify-center gap-3 mb-8 text-3xl">🕯️ 🕯️</div>

        <h1 className="text-4xl md:text-5xl font-light mb-6 tracking-wide">
          האתר שומר שבת
        </h1>

        <p className="text-lg text-white/80 mb-6">
          האתר יחזור לפעילות במוצאי שבת
        </p>

        {/* Countdown */}
        {timeLeft && (
          <div className="text-3xl font-light tracking-[0.2em] text-blue-300 mb-8">
            {timeLeft}
          </div>
        )}

        <div className="w-20 h-[1px] bg-white/20 mx-auto mb-8"></div>

        <p className="text-white/60 text-sm">
          משרד עורכי דין ארז עזרא מאחל שבת שלום
        </p>
      </div>
    </div>
  );
};

export default ShabbatPage;
